import React, { useRef } from 'react';
import T from 'prop-types';

import Report from './Report';
import MoreReporsCard from './MoreReporsCard';
import useFillUpRow from './hook/useFillUpRow';

const Reports = ({
  reports,
  type,
  eventId,
  disabledLibrary,
  isLoggedUser,
  permissions,
  reportCardStyle,
}) => {
  const reportsCount = reports?.length ? reports.length + (disabledLibrary ? 1 : 0) : 0;
  const wrapperRef = useRef(null);
  const additionalCards = useFillUpRow(
    disabledLibrary ? reports.slice(0, 9).length : reportsCount,
    wrapperRef,
    reportCardStyle
  );

  if (!reports?.length) {
    return (
      <div className="d-flex flex-column justify-content-center">
        <h1 className="text-black text-center text-24 m-b-xxs l-h-xxs">
          No reports found for the current filters
        </h1>
        <h3 className="text-quiet text-center text-16 m-b-mdl l-h-xxs">
          Please expand your search
        </h3>
      </div>
    );
  }
  const sliced = disabledLibrary ? reports.slice(0, 9) : reports;

  return (
    <div className="w-100">
      <div className="report-cards-wrapper" ref={wrapperRef}>
        {sliced.map((report) => (
          <Report
            key={report.id}
            report={report}
            type={type}
            eventId={eventId}
            disabledLibrary={disabledLibrary}
            permissions={permissions}
          />
        ))}
        {disabledLibrary && <MoreReporsCard isLoggedUser={isLoggedUser} />}
        {additionalCards}
      </div>
    </div>
  );
};

Reports.propTypes = {
  reports: T.array,
  type: T.string,
  eventId: T.number,
  disabledLibrary: T.bool,
  isLoggedUser: T.bool,
  permissions: T.object,
  reportCardStyle: T.object,
};

export default Reports;
